import React from 'react';
import '../style.scss';
import './style.scss';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishCheck } from 'views/components/atoms/establishes/check';
import { EstablishLink } from 'views/components/atoms/establishes/link';
import { EstablishError } from 'views/components/atoms/establishes/error';

export type InputDocumentConsentProps = {
  title: string;
  name: string;
  checkText: string;
  linkTitle?: string;
  linkUrl?: string;
  onClickLink?: () => void;
  isChecked: boolean;
  disabled?: boolean;
  setIsChecked: (e: React.ChangeEvent<HTMLInputElement>) => void;
  announceText?: string;
  isEnable: boolean;
  errorText?: string;
  batchDangerWord?: string;
};
/*
*リンク配置と注意文言配置
*TODO:　適当なコンポーネント名に変更必要あり
*/
export const InputDocumentConsent = (props: InputDocumentConsentProps) => {
  const {
    title,
    name,
    checkText,
    linkTitle,
    linkUrl,
    onClickLink,
    isChecked,
    disabled,
    setIsChecked,
    announceText,
    isEnable,
    errorText,
    batchDangerWord,
  } = props;
  return (
    <div className="inputWrapper inputWrapper_establishLink">
      <EstablishHeader headerTitle={title} batchDangerWord={batchDangerWord} />
      <EstablishLink linkTitle={linkTitle} linkUrl={linkUrl} onClick={onClickLink} />
      <fieldset className={name}>
        <EstablishCheck
          name={name}
          text={checkText}
          isChecked={isChecked}
          disabled={disabled}
          setIsChecked={setIsChecked}
        />
      </fieldset>
      <div className='announceText'>{announceText}</div>
      <EstablishError isEnabled={isEnable} errorText={errorText} />
    </div>
  );
};
